import { Skeleton, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(0.5),
}));

export const Label = styled(Typography)(({ theme }) => ({
  fontSize: 13,
  color: theme.palette.text.secondary,
}));

export const Value = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "$hovered",
})<{ $hovered: boolean }>(({ $hovered, theme }) => ({
  fontSize: 13,
  fontWeight: 500,
  color: $hovered ? theme.palette.text.primary : theme.palette.text.secondary,
}));

export const ValueSkeleton = styled(Skeleton)({
  width: 42,
  height: 13,
  transform: "none",
});
